module.exports = __webpack_public_path__ + "img/asset12.4bc5f647.png";